// Глобальный алерт-баннер «N документов требуют ручной проверки».
//
// PRD §17 №19 + §14 «Алерты». После sanity-check'а конвертации воркер
// выставляет ``documents.needs_manual_review=true``; этот баннер —
// UI-канал того самого «алерта». Email-канал параллельно отрабатывает
// в conversion worker (ADMIN_ALERT_EMAIL).
//
// Баннер тихо скрывается, если документов с флагом нет. Опрос мягкий
// (60 сек) — sanity-check не критическое событие, частый поллинг не
// нужен; пользователь увидит свежий счётчик при следующем рендере.

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { documentsApi } from "../api/documents";

const REFRESH_INTERVAL_MS = 60_000;

export function ManualReviewAlert() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const r = await documentsApi.list({ needs_review: true, size: 1 });
        if (!cancelled) setCount(r.total_count);
      } catch {
        if (!cancelled) setCount(null);
      }
    }
    void load();
    const id = window.setInterval(() => void load(), REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  if (!count) return null;

  return (
    <div
      role="alert"
      data-testid="manual-review-alert"
      className="border-b border-amber-300 bg-amber-50 text-amber-900"
    >
      <div className="max-w-6xl mx-auto px-4 py-2 text-sm flex items-center justify-between gap-3">
        <span>
          {count === 1
            ? "1 документ требует проверки"
            : `${count} документов требуют проверки`}
          : возможно, часть страниц не конвертировалась. Откройте документ и
          сверьте со страницами оригинала.
        </span>
        <Link
          to="/documents?needs_review=1"
          className="underline hover:no-underline whitespace-nowrap"
        >
          Открыть список →
        </Link>
      </div>
    </div>
  );
}
